var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.1406142%",
    y1: "20.1284775%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte---Filter-eingeklappt",
    transform: "translate(-28.000000, -504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-Versicherte-Active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users-(1)",
    transform: "translate(29.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,19 C15,16 12.1875,13 7.5,13 C2.8125,13 0,16 0,19",
    id: "Path",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,14.8333333 C23.4820056,14.2777778 22.6991253,14 21.6513589,14 C18.5020013,14 17,16.5 17,19",
    id: "Path-Copy",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(20.500000, 16.500000) scale(-1, 1) translate(-20.500000, -16.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 7.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "url(#linearGradient-1)",
    cx: 19,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#263238",
    strokeWidth: 2,
    cx: 7.5,
    cy: 5.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#263238",
    strokeWidth: 2,
    cx: 19,
    cy: 8,
    r: 3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDark);
export default __webpack_public_path__ + "static/media/users-dark.c314640fa56b5919499334e77846db99.svg";
export { ForwardRef as ReactComponent };